export default __webpack_public_path__ + "static/media/example-art.9c47a906.webp";